// @ts-ignore
import '@/shared/styles/index.css';

import { HeroUIProvider, ToastProvider } from '@heroui/react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

/**
 * Punto de entrada principal de la aplicación React.
 *
 * Funcionalidad:
 * - Inicializa la aplicación React en el elemento DOM con id "root"
 * - Configura los providers globales de la aplicación (HeroUI, Toast, Router)
 * - Habilita StrictMode para detectar problemas potenciales en desarrollo
 *
 * Responsabilidades:
 * - Obtener el elemento raíz del DOM donde se montará la aplicación
 * - Crear la raíz de React con ReactDOM.createRoot
 * - Envolver la aplicación con providers necesarios (HeroUI con locale español, ToastProvider con configuración, RouterProvider)
 * - Renderizar la aplicación en modo estricto
 */
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <HeroUIProvider locale="es">
        <ToastProvider maxVisibleToasts={5} placement="bottom-right" />
        <RouterProvider router={router} />
      </HeroUIProvider>
    </StrictMode>,
  );
}
